module.exports = __webpack_public_path__ + "static/media/sedo.bddac559.png";